/* eslint-disable import/no-unresolved */
/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Taxes } from '@/components/Invoices/InvoiceItem';

export type PaymentMethod = {
  type: string;
  amount: number;
};

export type Business_details = {
  businessAccountName: string;
  businessAccountNumber: string;
  businessBankName: string;
  enableDetailsOnBill: number;
  enableDispensePoint: number;
};

interface OrderType {
  restaurant_table: string;
  customer: string;
  customer_balance: number;
  paid_amount: number;
  is_occupied: boolean;
  current_invoice: string;
  cartState: 'view' | 'edit';
  timeCreated: string;
  taxes: Taxes[];
  discount: number;
  change: number;
  prev_change: number;
  changeGiven: number;
  changeSaved: number;
  paymentMethod: Array<PaymentMethod>;
  sub_total: number;
  total: number;
  service_charge: boolean;
  apply_change: boolean;
  business_details: Business_details;
}

const OrderState: OrderType = {
  restaurant_table: '',
  customer: '',
  customer_balance: 0,
  is_occupied: false,
  current_invoice: '',
  cartState: 'edit',
  timeCreated: '',
  taxes: [],
  discount: 0,
  change: 0,
  prev_change: 0,
  changeGiven: 0,
  changeSaved: 0,
  paid_amount: 0,
  paymentMethod: [],
  sub_total: 0,
  total: 0,
  service_charge: false,
  apply_change: false,
  business_details: {
    businessAccountName: '',
    businessAccountNumber: '',
    businessBankName: '',
    enableDetailsOnBill: 0,
    enableDispensePoint: 0,
  },
};

const orderSlice = createSlice({
  name: 'order',
  initialState: OrderState,
  reducers: {
    addTable: (state: OrderType, { payload }: PayloadAction<string>) => {
      state.restaurant_table = payload;
    },
    addBusinessDetails: (
      state: OrderType,
      { payload }: PayloadAction<Business_details>,
    ) => {
      state.business_details = payload;
    },
    addCustomer: (state: OrderType, { payload }: PayloadAction<string>) => {
      state.customer = payload;
    },
    addCustomerBalance: (
      state: OrderType,
      { payload }: PayloadAction<number>,
    ) => {
      state.customer_balance = payload;
    },
    toogleOccupied: (state: OrderType, { payload }: PayloadAction<boolean>) => {
      state.is_occupied = payload;
    },
    toogleServiceCharge: (
      state: OrderType,
      { payload }: PayloadAction<boolean>,
    ) => {
      state.service_charge = payload;
    },
    updateInvoice: (state: OrderType, { payload }: PayloadAction<string>) => {
      state.current_invoice = payload;
    },
    updateCartState: (
      state: OrderType,
      { payload }: PayloadAction<'view' | 'edit'>,
    ) => {
      state.cartState = payload;
    },
    updateTax: (state: OrderType, { payload }: PayloadAction<Taxes[]>) => {
      state.taxes = payload;
    },
    updateDiscount: (state: OrderType, { payload }: PayloadAction<number>) => {
      state.discount = payload;
    },

    addTime: (state: OrderType, { payload }: PayloadAction<string>) => {
      state.timeCreated = payload;
    },
    updateChange: (state: OrderType, { payload }: PayloadAction<number>) => {
      state.change = payload;
    },
    updatePrevChange: (
      state: OrderType,
      { payload }: PayloadAction<number>,
    ) => {
      state.prev_change = payload;
    },
    updateChangeGiven: (
      state: OrderType,
      { payload }: PayloadAction<number>,
    ) => {
      state.changeGiven = payload;
    },
    updateChangeSaved: (
      state: OrderType,
      { payload }: PayloadAction<number>,
    ) => {
      state.changeSaved = payload;
    },
    updatePaidAmount: (
      state: OrderType,
      { payload }: PayloadAction<number>,
    ) => {
      state.paid_amount = payload;
    },
    updateSubTotal: (state: OrderType, { payload }: PayloadAction<number>) => {
      state.sub_total = payload;
    },
    updateTotal: (state: OrderType, { payload }: PayloadAction<number>) => {
      state.total = payload;
    },
    applyChange: (state: OrderType, { payload }: PayloadAction<boolean>) => {
      state.apply_change = payload;
    },
    updatePaymentMethod: (
      state: OrderType,
      { payload }: PayloadAction<Array<PaymentMethod>>,
    ) => {
      state.paymentMethod = payload;
    },
  },
});

export const {
  addCustomer,
  addCustomerBalance,
  addTable,
  toogleOccupied,
  toogleServiceCharge,
  updateInvoice,
  updateCartState,
  addTime,
  updateTax,
  updateDiscount,
  updateChange,
  updateChangeGiven,
  updateChangeSaved,
  updatePaymentMethod,
  updatePaidAmount,
  updateSubTotal,
  updateTotal,
  applyChange,
  updatePrevChange,
  addBusinessDetails,
} = orderSlice.actions;

export default orderSlice.reducer;
